exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HashtagLink{position:relative;white-space:normal;display:inline-block;color:var(--link)}", ""]);

// exports
